export default "__VITE_ASSET__YpgrDFEK__"